import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ChangableComponent } from '@models/changable.component';
import { Store } from '@ngrx/store';
import { subscribeToUser, unsubscribeFromUser } from '@store/actions/users.actions';
import { FeatureEnum } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs';
import { AccountService, AuthService, ContextService, FeaturesService } from '../../services';

@Component({
  selector: 'app-subscribe',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule],
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscribeComponent extends ChangableComponent implements OnInit {
  private authService = inject(AuthService);
  private store = inject(Store);
  deviceService = inject(DeviceDetectorService);
  contextService = inject(ContextService);
  accountService = inject(AccountService);
  features = inject(FeaturesService);

  @Input() user_id: string;
  @Input() separate = false;
  public isSubscribed = true;
  public me$ = this.contextService.me$;

  ngOnInit(): void {
    this.accountService
      .getUserById(this.user_id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (user) => {
          this.isSubscribed = user?.visit_info?.is_subscribed;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.isSubscribed = false;
          this.detectChanges();
        },
      });
  }

  public onToggleSubscribe() {
    if (!this.authService.isAuthenticated) {
      this.authService.showAuthModal(() => {
        this.checkAction();
      });
    } else {
      this.checkAction();
    }
  }

  public checkAction() {
    if (this.isSubscribed) {
      this.store.dispatch(unsubscribeFromUser({ user_id: this.user_id }));
    } else {
      this.store.dispatch(subscribeToUser({ user_id: this.user_id }));
    }
    this.isSubscribed = !this.isSubscribed;
  }

  public get isAvailableStatistics() {
    return this.features.isAvailable(FeatureEnum.statistics);
  }
}
